import React from "react";
import ComplianceDocument from "../components/ui/ComplianceDocument";

export default function DataRetentionPage(): React.JSX.Element {
  return (
    <ComplianceDocument
      slug="data-retention"
      title="Data Retention & Deletion Schedule"
      description={
        <span>
          How long <strong>kivo.skin</strong> keeps each kind of data, and how it is deleted.
          Photos are destroyed no later than 3 years after your last use of the service.
        </span>
      }
    />
  );
}
